export class Menu {
    title;
    page;
    subList;

    constructor(title: string, page: number, subList?: Array<any>) {
        this.title = title;
        this.page = page;
        this.subList = subList;
    }
}

// export type{ Menu }

